import { render, staticRenderFns } from "./HomeCover.vue?vue&type=template&id=0f3ed3f7&scoped=true&"
import script from "./HomeCover.vue?vue&type=script&lang=js&"
export * from "./HomeCover.vue?vue&type=script&lang=js&"
import style0 from "./HomeCover.vue?vue&type=style&index=0&id=0f3ed3f7&prod&lang=css&"
import style1 from "./HomeCover.vue?vue&type=style&index=1&id=0f3ed3f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ed3f7",
  null
  
)

export default component.exports